import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getEventFn = () => {
    const response = protectedApi.get(`${ENDPOINTS.event_api}`);
    return response;
}

export const getEventByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.event_api}?event_id=${id}`);
    return response;
}

export const postEventFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.event_api}`, reqBody);
    return response;
}

export const patchEventFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.event_api}`, reqBody);
    return response;
}

export const deleteEventFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.event_api}`, { data: reqBody });
    return response;
}
